import React from 'react';
import Seo from './Seo';

const ScadaSolutions = () => {
  const title = 'SCADA Solutions Dubai, UAE — SCADA Systems & Services | Fusion Tech';
  const description = 'Fusion Tech provides SCADA solutions in Dubai — system design, PLC integration, telemetry and commissioning by experienced SCADA engineers.';
  const url = 'https://fusiontechuae.com/scada-solutions-dubai/';

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "SCADA Solutions",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Fusion Tech General Trading FZCO",
      "telephone": "+971522340058",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "IFZA Business Park Building A1",
        "addressLocality": "Dubai Silicon Oasis",
        "addressRegion": "Dubai",
        "addressCountry": "AE"
      }
    },
    "areaServed": "Dubai",
    "description": description
  };

  return (
    <div>
      <Seo
        title={title}
        description={description}
        url={url}
        keywords="SCADA Solutions in Dubai, UAE, Telemetry Solutions in Dubai UAE, PLC, RTU, DCS from Dubai, Industrial Automation Dubai UAE, Control Panels from Dubai"
        jsonLd={jsonLd}
      />
      <main className="container mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-4">SCADA Solutions in Dubai, UAE</h1>
        <p className="text-gray-700 mb-4">Our SCADA solutions deliver centralized monitoring, control and telemetry for industrial plants across Dubai. We design, integrate and commission SCADA systems tailored to your operational needs.</p>
        <p className="text-gray-700 mb-6">
          Telemetry Solutions in Dubai UAE, Industrial Automation Dubai UAE, and spare parts support: Electrical Spare Parts in Dubai UAE, Automation Spare Parts Dubai UAE,
          PLC, RTU, DCS from Dubai, Control Panels from Dubai, and Machine Supply from Dubai.
        </p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">SCADA services</h2>
          <ul className="list-disc ml-6 mt-2 text-gray-700">
            <li>SCADA system design and architecture</li>
            <li>PLC and RTU integration (Modbus, OPC UA, IEC protocols)</li>
            <li>HMI development, historian and reporting</li>
            <li>Remote telemetry and cloud integration</li>
            <li>Commissioning, training and support</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Why Fusion Tech for SCADA</h2>
          <p className="text-gray-700">We partner with leading SCADA vendors and combine hardware expertise with software engineering to deliver reliable, scalable control systems. Our team focuses on cybersecurity, uptime and operational analytics.</p>
        </section>

        <section className="mt-8">
          <a className="inline-block bg-fusion-blue text-white px-5 py-3 rounded" href="/contactus">Request a SCADA consultation</a>
          <a className="inline-block ml-3 text-fusion-blue font-medium" href="/electromechanical-systems-dubai">Electromechanical Systems Supply and Installation in Dubai →</a>
        </section>
      </main>
    </div>
  );
};

export default ScadaSolutions;
